import { Component, AfterViewInit } from "@angular/core";

import { LoggerService } from "#core/services/logger.service";
import { LocalStorage } from "#core/services/local-storage.service";

@Component({
    selector: "app-root",
    styleUrls: ["app.component.scss"],
    templateUrl: "app.component.html",
    standalone: false
})
export class AppComponent implements AfterViewInit {
    indexStartTime: number = (<any>window).indexStartTime;

    constructor(
        private loggerService: LoggerService,
        private localStorage: LocalStorage
    ) {
        const angularStartUpTime = Date.now();
        const totalAngularLoadTime = angularStartUpTime - this.indexStartTime;

        this.loggerService.cacheMessage({
            angularStartUpTime: totalAngularLoadTime
        });

        if (location.href.includes("/authorize")) {
            // In p5.0 release Hash URL strategy was released but Clever and ClassLink SSO services
            // append params before the # so we need to intercept and store this data when found
            this.storeOAuth2Code();
        }

        // v6 world of deployments DO NOT use env = x but a string "p6-demo...."
        // we need to check and set a global variable to indicate if the env is a demo env
        const demoIndex = ((<any>window).env).search('demo');
        if (demoIndex > -1 || ((<any>window).env) === "x") {
            (<any>window).isDemo = true;
        }
    }

    ngAfterViewInit(): void {
        const angularContentStartTime = Date.now();
        const totalAngularContentLoadTime =
            angularContentStartTime - this.indexStartTime;

        this.loggerService.cacheMessage({
            angularContentLoadTime: totalAngularContentLoadTime
        });
    }

    storeOAuth2Code() {
        let match;
        const pl = /\+/g; // Regex for replacing addition symbol with a space
        const search = /([^&=]+)=?([^&]*)/g;
        const decode = function(s: string) {
            return decodeURIComponent(s.replace(pl, " "));
        };
        const query = window.location.search.substring(1);

        const urlParams: any = {};
        while ((match = search.exec(query))) {
            urlParams[decode(match[1])] = decode(match[2]);
        }

        if (urlParams.code) {
            this.localStorage.set("oAuth2Code", urlParams.code);
        }
    }
}
